import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [me, setMe] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [cols, setCols] = useState([]);

  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const meRes = await Http.get(`/me`);
      setMe(meRes?.data?.data);
      console.log(meRes?.data?.data, "data");

      // Only call the API if the user is not an admin
      if (meRes.data.data.department_art_id === 1) {
        const res = await Http.get(`/stock/body`);
        setReceiveData(res.data);
      } else if (
        meRes.data.data.department_art_id === 2 ||
        meRes.data.data.department_art_id === 3
      ) {
        const res = await Http.get(`/stock/jigger-casting-stock`);
        setReceiveData(addSourceGroupLabel(res.data));
      } else if (
        meRes.data.data.department_art_id === 4 ||
        meRes.data.data.department_art_id === 5 ||
        meRes.data.data.department_art_id === 6
      ) {
        const res = await Http.get(`/stock/finishing-bk-stock`);
        setReceiveData(res.data);
      } else if (meRes.data.data.department_art_id === 7) {
        const res = await Http.get(`/stock/glazing-gk-stock`);
        setReceiveData(addSourceGroupLabel(res.data));
      } else if (meRes.data.data.department_art_id === 8) {
        const res = await Http.get(`/stock/selection-stock`);
        setReceiveData(res.data);
      } else if (
        meRes.data.data.department_art_id === 9 ||
        meRes.data.data.department_art_id === 10 ||
        meRes.data.data.department_art_id === 11 ||
        meRes.data.data.department_art_id === 33
      ) {
        const res = await Http.get(
          `/stock/decoration-local-export-dfw-firing-stock`
        );
        setReceiveData(addSourceGroupLabel(res.data));
      } else if (
        meRes.data.data.department_art_id === 12 ||
        meRes.data.data.department_art_id === 13
      ) {
        const res = await Http.get(`/stock/packaging-local-export-stock`);
        setReceiveData(addSourceGroupLabel(res.data));
      } else if (
        meRes.data.data.department_art_id === 16 ||
        meRes.data.data.department_art_id === 19
      ) {
        const res = await Http.get(`/stock/mould-stock`);
        setReceiveData(res.data);
      } else if (meRes.data.data.department_art_id === 14) {
        const res = await Http.get(`/stock/decal-production-stock`);
        setReceiveData(res.data);
      } else if (meRes.data.data.department_art_id === 17) {
        const res = await Http.get(`/stock/packaging-production-stock`);
        setReceiveData(res.data);
      } else if (
        meRes.data.data.user_type !== "admin" &&
        (meRes.data.data.department_art_id === 15 ||
        meRes.data.data.department_art_id === 21 ||
          meRes.data.data.department_art_id === 20)
      ) {
        const res = await Http.get(`/all-product-stock`);
        setReceiveData(addSourceGroupLabel(res.data.info));
      }

      const resRole = await Http.get(`/staff-type-check`);
      setRole(resRole.data);

      // Build columns using simple if/else based on me.data.data.department_art_id
      const deptId = meRes.data.data?.department_art_id;
      let colsLocal = [
        { field: "code", header: "Code" },
        { field: "name", header: "Name" },
        { field: "unit_name", header: "Unit" },
      ];
      if (deptId === 1) {
        colsLocal.push(
          { field: "type", header: "Type" },
          { field: "stockQty", header: "Stock" }
        );
      } else if (deptId === 2 || deptId === 3) {
        colsLocal.push(
          { field: "shape_name", header: "Shape" },
          { field: "stockQty", header: "Stock" },
          { field: "source_group_label", header: "From" },
          { field: "filter_cake_out_kg", header: "Filter Cake Out (kg)" }
        );
      } else if (deptId === 4 || deptId === 5) {
        colsLocal.push(
          { field: "shape_name", header: "Shape" },
          { field: "stockQty", header: "Stock" }
        );
      } else if (deptId === 6 || deptId === 7) {
        colsLocal.push(
          { field: "shape_name", header: "Shape" },
          { field: "glaze_name", header: "Glaze" },
          { field: "stockQty", header: "Stock" },
          { field: "source_group_label", header: "From" }
        );
      } else if (deptId === 8) {
        colsLocal.push(
          { field: "shape_name", header: "Shape" },
          { field: "glaze_name", header: "Glaze" },
          { field: "stockQty", header: "Stock" },
          { field: "stockQtyExportClass", header: "Qty Export" },
          { field: "stockQtyAClass", header: "Qty A Class" },
          { field: "stockQtyBClass", header: "Qty B Class" },
          { field: "stockQtyCClass", header: "Qty C Class" }
        );
      } else if (
        deptId === 9 ||
        deptId === 10 ||
        deptId === 11 ||
        deptId === 33
      ) {
        colsLocal.push(
          { field: "shape_name", header: "Shape" },
          { field: "glaze_name", header: "Glaze" },
          { field: "decoration_code", header: "Deco Code" },
          { field: "decoration_name", header: "Deco Name" },
          { field: "stockQtyExportClass", header: "Qty Export" },
          { field: "stockQtyAClass", header: "Qty A Class" },
          { field: "stockQtyBClass", header: "Qty B Class" },
          { field: "stockQtyCClass", header: "Qty C Class" },
          { field: "source_group_label", header: "From" },

        );
      } else if (deptId === 12 || deptId === 13) {
        colsLocal.push(
          { field: "shape_name", header: "Shape" },
          { field: "glaze_name", header: "Glaze" },
          { field: "decoration_code", header: "Deco Code" },
          { field: "decoration_name", header: "Deco Name" },
          { field: "transfer_receive_inner_qty", header: "Inner Qty" },
          { field: "transfer_receive_master_qty", header: "Master Qty" },
          { field: "stockQtyExportClass", header: "Qty Export" },
          { field: "stockQtyAClass", header: "Qty A Class" },
          { field: "stockQtyBClass", header: "Qty B Class" },
          { field: "stockQtyCClass", header: "Qty C Class" },
          { field: "from_department_art_id", header: "From" },
        );
      } else if (deptId === 14) {
        colsLocal.push(
          { field: "shape_name", header: "Shape" },
          { field: "glaze_name", header: "Glaze" },
          { field: "decoration_code", header: "Deco Code" },
          { field: "decoration_name", header: "Deco Name" },
          { field: "stockQty", header: "Stock" },
          { field: "stockQtyExport", header: "Qty Export" },
          { field: "stockQtyAClass", header: "Qty A Class" },
          { field: "stockQtyBClass", header: "Qty B Class" },
          { field: "stockQtyCClass", header: "Qty C Class" }
        );
      } else if (deptId === 16 || deptId === 19) {
        colsLocal.push(
          { field: "shape_name", header: "Shape" },
          { field: "stockQty", header: "Stock" }
        );
      } else if (deptId === 17) {
        colsLocal.push(
          { field: "shape_name", header: "Shape" },
          { field: "glaze_name", header: "Glaze" },
          { field: "decoration_code", header: "Deco Code" },
          { field: "decoration_name", header: "Deco Name" },
          { field: "stockQty", header: "Stock" },
          { field: "stockInnerQty", header: "Inner Qty" },
          { field: "stockMasterQty", header: "Master Qty" }
        );
      } else {
        colsLocal.push({ field: "stockQty", header: "Stock" });
      }
      setCols(colsLocal);
    } catch (error) {
      console.error("Fetch error:", error);
      const msg =
        error && error.message ? error.message : "Failed to fetch stock data";
      showAlert(msg, "error");
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  // useEffect(() => {
  //   if (!location.state) {
  //     return;
  //   }
  //   showAlert(location.state.message, location.state.type);
  // }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };
  console.log(me, "me");

  function formatType(value) {
    if (!value) return ""; // Handle empty or undefined values
    return value
      .split("_") // Split the string by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(" "); // Join the words back with spaces
  }

  const formatSourceGroup = (value) => {
    const v = parseInt(value, 10);
    if (Number.isNaN(v)) return "";
    if (v === 16) return "Mould";
    if (v === 19) return "Sagger";
    if (v === 17) return "Packaging Production";
    if (v === 14) return "Decel Production";
    return "";
  };

  const addSourceGroupLabel = (rows) => {
    if (!Array.isArray(rows)) return rows;
    return rows.map((r) => ({
      ...r,
      source_group_label: formatSourceGroup(r?.source_group),
    }));
  };

  const handleStoreChange = (event) => {
    setSelectedStore(parseInt(event.target.value));
    // You can also handle any additional logic based on the selected store here
  };

  const handleSubmit = async () => {
    if (!selectedStore) {
      showAlert("Please select a store.", "error");
      return;
    }

    try {
      const response = await Http.post("/all-store-stock-admin", {
        department_art_id: selectedStore,
      });
      showAlert("Store submitted successfully!", "success");
      setReceiveData(response?.data?.info);
    } catch (error) {
      showAlert("Error submitting store.", "error");
    }
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* Dropdown for store selection */}

      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            {/* if role is admin then h5 tag is "Store Stocks" else the following one */}
            {role === "admin" ? (
              <h5 className="am-title">Store Stocks</h5>
            ) : (
              <h5 className="am-title">Stock Without Breakdown</h5>
            )}
            {/* <h5 className="am-title">Stock Without Breakdown</h5> */}
            {/* <Link to="/create-damage-return" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i>New Damage Return
              </Link> */}
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />
            {role === "admin" && (
              <div className="card">
                <label className="col-3">Select Store:</label>
                <select
                  name="store-select"
                  className="form-control col-4"
                  value={selectedStore}
                  onChange={handleStoreChange}
                >
                  <option value="">--Please choose an option--</option>
                  <option value={15}>General Store</option>
                  <option value={20}>Decel Store</option>
                  <option value={21}>Packaging Store</option>
                </select>
                <button
                  className="btn btn-primary col-2 mt-2"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            )}

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
